import { Component, Inject, OnInit, Optional } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { NotifyUsersBy } from '../../constants/KRollConstants';
import { KRollService } from '../../services/api-services/kroll.service';
import { ShippingService } from '../../services/api-services/shipping.service';
import { FormService } from '../../services/form.service';
import { arrayMinLengthByKey } from '../../validator/form-validators.service';
import { ValidationMessagesService } from '../../validator/validation-messages.service';

@Component({
  selector: 'app-warning-order-popup',
  templateUrl: './warning-order-popup.component.html',
  styleUrls: ['./warning-order-popup.component.scss']
})
export class WarningOrderPopupComponent implements OnInit {
  isResult: 'noDeliverPartner' | 'processOrder' | 'processedResult' = 'processOrder';
  isLoading: boolean = false;
  pendingPayments: any[] = [];
  tenant: any = localStorage.getItem('tenant')
  response: any;
  result: any = {
    successfull: 0,
    unSuccessfull: [],
    noDeliveryPartner: []
  };
  form!: FormGroup;
  canadaPostForm!: FormGroup;
  currentDate = new Date()
  constructor(public dialogRef: MatDialogRef<WarningOrderPopupComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public props: any,
    public shippingService: ShippingService,
    public krollService: KRollService,
    public validationMessagesService: ValidationMessagesService,
    public fb: FormBuilder,
    public toast: ToastrService,
    private formService: FormService
  ) { }

  ngOnInit(): void {
    this.filterUnSelectedDP();
    this.countPendingOrders();
    this.initializeNotifyForm();
    this.initializeCanadaPostForm();
  }
  get emptyUsers() {
    let users = this.props.orders.filter((m: any) => m.UserID == 0);
    return users.length > 0 ? users : [];
  }
  filterUnSelectedDP() {
    let noDeliveryPartner = this.props.orders.filter((f: any) => !f.DeliveryPartnerID);
    if (noDeliveryPartner.length > 0) {
      this.result.noDeliveryPartner = this.props.orders.filter((f: any) => !f.DeliveryPartnerID);
      this.isResult = 'noDeliverPartner';
    }
  }
  countPendingOrders() {
    this.pendingPayments = this.props.orders.filter((f: any) => f.SalesOrderStatusID === 1 || f.SalesOrderStatus.includes('Waiting for Payment'));
  }
  get waitingForPaymentOrderIds() {
    return this.pendingPayments.map((m: any) => m.OrderID).join(", ");
  }
  get orderIds() {
    return this.props.orders.map((m: any) => m.OrderID).join(", ");
  }
  onCheckChange(event: MatCheckboxChange) {
    if (event.checked) {
      this.form.addControl('NotifyUsersBy', this.fb.array([], arrayMinLengthByKey(1, 'isChecked')));
      NotifyUsersBy.forEach((x: any) => {
        this.notifyByArray.push(this.fb.group({
          id: new FormControl(x.id),
          value: new FormControl(x.value),
          isChecked: new FormControl(x.isChecked),
          disable: new FormControl(this.tenant == 'sl' ? true : false)
        }));
      });
    }
    else {
      this.form.removeControl('NotifyUsersBy');
    }
  }

  // Utility: safe encode function
  safeEncode(value: string): string {
    try {
      // if decodeURIComponent returns the same string it means it was not encoded
      if (decodeURIComponent(value) == value) {
        return encodeURIComponent(value);
      }
      return value; // already encoded
    } catch (e) {
      // if decode failed then can assume already encoded
      return value;
    }
  }

  onProceedClick() {
    if (this.form.valid) {
      this.props.payload.NotifyUsers = this.form.value.NotifyUsers;
      if (this.form.value.NotifyUsersBy?.length > 0) {
        this.props.payload.NotifyUsersBy = this.form.value.NotifyUsersBy.filter((f: any) => f.isChecked).map((m: any) => m.id);
      }
      if (this.shippingService.deliveryPartnerName == 'Canada Post') {
        this.props.payload.PickupRequest = this.canadaPostForm.value
      }
      this.props.payload.Shipments.forEach((shipment: any) => {
        const receiverInfo = shipment.Shipment?.ReceiverInformation;
        const fieldsToEncode = [
          'Address1',
          'Address2',
          'StreetName',
          'Geolocation',
          'FirstName',
          'LastName',
          'Delivery_instruction',
          'Name',
          'City'
        ];
        if (receiverInfo) {
          fieldsToEncode.forEach((field) => {
            if (receiverInfo[field] && typeof receiverInfo[field] == 'string') {
              receiverInfo[field] = this.safeEncode(receiverInfo[field]);
            }
          });
        }
        // encode Notes field safely
        if (shipment?.Shipment?.Notes && typeof shipment.Shipment.Notes == 'string') {
          shipment.Shipment.Notes = this.safeEncode(shipment.Shipment.Notes);
        }
      });
      this.isLoading = true;
      this.shippingService.create_shipment_order(this.props.payload).subscribe(res => {
        this.response = res;
        if (res.body.success) {
          this.result.successfull = res.body.data.list.filter((f: any) => f.Success)?.length;
          this.result.unSuccessfull = res.body.data.list.filter((f: any) => !f.Success);
          this.isResult = 'processedResult';
          if (res.body.data.TrackingLabelMergeUrl) {
            let a = document.createElement("a");
            a.href = res.body.data.TrackingLabelMergeUrl;
            a.target = '_blank';
            a.click();
          }
          this.krollService.get_sales_order_status({ server_location: this.formService.selectedLocation.value });
          this.isLoading = false;
        }
        else {
          this.isLoading = false;
          this.toast.error(res.body.message[0]);
        }
      }, err => {
        this.isLoading = false;
        this.toast.error(err.message[0]);
      });
    }
    else {
      this.validationMessagesService.validateAllFormFields(this.form);
    }
  }
  continue() {
    this.dialogRef.close({ payload: this.props.payload, response: this.response?.body });
  }
  initializeNotifyForm() {
    this.form = this.fb.group({
      NotifyUsers: new FormControl(),
    });
  }
  get notifyByArray() {
    return this.form.get('NotifyUsersBy') as FormArray
  }

  initializeCanadaPostForm() {
    this.canadaPostForm = this.fb.group({
      PickupType: new FormControl("OnDemand"),
      PickupVolume: new FormControl("1200"),
      Date: new FormControl(this.currentDate),
      PreferredTime: new FormControl("12:00"),
      ClosingTime: new FormControl("17:00"),
      Email: new FormControl("shipping@pillway.com"),
      Name: new FormControl("Pillway Pharmacy"),
      Phone: new FormControl("123-456-7890"),
    });
  }
  onChangeHour(event: any) {
    console.log('event', event);
  }
}
